export const convites = {
  status: { nao_enviado: 'Não enviado', enviado: 'Aceito pelo servidor', falha: 'Falha' },
  lembrar: {
    titulo_one: '{{count}} não respondeu',
    titulo_other: '{{count}} não responderam',
    enviar: 'Enviar e-mail',
    pessoas_zero: '{{count}} pessoas',
    pessoas_one: '{{count}} pessoa',
    pessoas_other: '{{count}} pessoas',
    copiarEmails: 'Copiar e-mails',
    bloco: '{{de}}–{{ate}}',
    copiarLink: 'Copiar link',
    copiados_one: '{{count}} copiado',
    copiados_other: '{{count}} copiados',
    linkCopiado: 'Link copiado',
    semEmail: '{{count}} sem e-mail',
  },
  statusDica: {
    enviado:
      'O servidor de e-mail aceitou a mensagem; não significa que foi entregue nem lido. Não inclui comunicações pelo Teams ou WhatsApp.',
  },
  iniciadaIgnorados_one: 'Envio iniciado. {{count}} pessoa não estava na campanha e foi ignorada.',
  iniciadaIgnorados_other:
    'Envio iniciado. {{count}} pessoas não estavam na campanha e foram ignoradas.',
  previa: {
    titulo: 'Prévia do e-mail',
    de: 'De',
    para: 'Para',
    assunto: 'Assunto',
    exemplo: 'Exemplo com um nome fictício',
    semDestinatario: 'Esta pessoa não receberia o e-mail: sem e-mail ou domínio no cadastro',
    verPessoa: 'Ver o e-mail que esta pessoa recebe',
  },
  rodada: {
    status: { em_andamento: 'Em andamento' },
    barra: '{{processados}} · {{enviados}}, {{falhas}} com falha',
    processados_one: '{{feitos}} de {{count}} processado',
    processados_other: '{{feitos}} de {{count}} processados',
    enviados_zero: '{{count}} enviados',
    enviados_one: '{{count}} enviado',
    enviados_other: '{{count}} enviados',
  },
  ultimoEnvio: {
    titulo: 'Último envio de e-mails',
    concluido_zero: '{{count}} e-mails enviados em {{quando}} por {{nome}}',
    concluido_one: '{{count}} e-mail enviado em {{quando}} por {{nome}}',
    concluido_other: '{{count}} e-mails enviados em {{quando}} por {{nome}}',
    falhas_one: '{{count}} com falha',
    falhas_other: '{{count}} com falha',
    interrompido: 'O envio parou em {{quando}}: {{enviados}} de {{total}} enviados.',
  },
  detalhe: {
    semTentativas: 'Nenhuma tentativa de envio.',
    resultado: 'Motivo',
    historico: 'Tentativas',
  },
  idioma: {
    rotulo: 'Idioma do e-mail',
    cadaUm: 'O idioma de cada pessoa',
    previa: 'Ver em',
  },
  modelo: {
    titulo: 'Texto do e-mail',
    padrao: 'Texto padrão',
    editadoPor: 'Editado por {{nome}} em {{quando}}',
    corpo: 'Corpo',
    voltarSalvar: 'Voltar e salvar',
    saidaTitulo: 'Há texto não salvo',
    salvar: 'Salvar texto',
    descartar: 'Descartar',
    restaurar: 'Restaurar padrão',
    restaurarTitulo: 'Restaurar o texto padrão?',
    restaurarCorpo: 'O texto editado deste idioma é apagado e volta o padrão.',
    salvo: 'Texto salvo. Os próximos envios usam este texto.',
    restaurado: 'Texto padrão restaurado.',
    variavelDesconhecida:
      'Variável desconhecida no texto: {{variaveis}}. Use {nome}, {campanha}, {inicio} ou {fim}.',
  },
  envio: {
    publico_zero: '{{count}} pessoas',
    publico_one: '{{count}} pessoa',
    publico_other: '{{count}} pessoas',
    resumo: '{{pessoas}}, {{receberao}}',
    receberao_zero: '{{count}} receberão',
    receberao_one: '{{count}} receberá',
    receberao_other: '{{count}} receberão',
  },
  dialogo: {
    titulo: 'Enviar convites',
    enviar: 'Enviar',
  },
} as const;
